import React from 'react';
import {Modal, Button, Table, Badge} from 'react-bootstrap';
import moment from 'moment';

const EcsTaskDialog = ({show, onHide, taskData}) => {
    const {
        service_name,
        status,
        desired_count,
        running_count,
        pending_count,
        last_deployment,
        last_deployment_attempt,
        container_image_names,
        memory,
        cpu,
        active_task_definition,
        pending_task_definitions,
        min_task_count,
        max_task_count,
        opa_policy_version,
    } = taskData || {};

    const getStatusColor = () => {
        if (status !== 'ACTIVE') return 'danger';
        if (running_count === 0) return 'danger';
        if (pending_count > 0) return 'warning';
        if (desired_count === running_count) return 'success';
        return 'secondary';
    };

    const formatDate = (date) => moment(date).format('YYYY-MM-DD HH:mm:ss');

    const getImageNameWithoutRepo = (fullImageName) => {
        const parts = fullImageName.split('/');
        return parts[parts.length - 1];
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{service_name || 'ECS Task Details'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped bordered hover>
                    <tbody>
                    <tr>
                        <td>Status</td>
                        <td>
                            <Badge bg={getStatusColor()}>
                                {status} ({desired_count}/{running_count}/{pending_count})
                            </Badge>
                        </td>
                    </tr>
                    <tr>
                        <td>Last Deployment</td>
                        <td>
                            {formatDate(last_deployment)} ({moment(last_deployment).fromNow()})
                            {last_deployment_attempt !== last_deployment && (
                                <div className="text-warning">
                                    Last attempt: {formatDate(last_deployment_attempt)}
                                </div>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>Resources</td>
                        <td>{cpu / 1024} vCPU | {memory} MB RAM</td>
                    </tr>
                    <tr>
                        <td>Auto-scaling</td>
                        <td>{min_task_count} min / {max_task_count} max tasks</td>
                    </tr>
                    <tr>
                        <td>Active Task Definition</td>
                        <td>{active_task_definition}</td>
                    </tr>
                    {pending_task_definitions && (
                        <tr>
                            <td>Pending Task Definition</td>
                            <td className="text-warning">{pending_task_definitions}</td>
                        </tr>
                    )}
                    <tr>
                        <td>Container Images</td>
                        <td>
                            <ul className="list-unstyled">
                                {container_image_names.map((image, index) => (
                                    <li key={index}>
                                        {getImageNameWithoutRepo(image)}
                                    </li>
                                ))}
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>OPA Policy</td>
                        <td>
                            {opa_policy_version ? (
                                <ul className="list-unstyled">
                                    <li>
                                        {opa_policy_version.version}
                                    </li>
                                    <li>
                                        Deployed
                                        at {formatDate(opa_policy_version.deployedAt)} ({moment(opa_policy_version.deployedAt).fromNow()})
                                    </li>
                                </ul>
                            ) : (
                                "OPA not available"
                            )}
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EcsTaskDialog;

